// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__pEBCW","sk1":"loader_sk1__8grzK","grid2":"loader_grid2__fPGvE","grid2_skeletor":"loader_grid2_skeletor__YmEJE"};